import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

import ControlCenterChangeLog from '../../../release-notes/controlcenter.md';
import PlayerChangeLog from '../../../release-notes/hosted-player.md';
import ChannelListingChangeLog from '../../../release-notes/channel-listing.md';
import KnownIssues from '../../../release-notes/known-issues.md';

const ReleaseNotes = props => {

    let [ tab, setTab ] = useState(0)

    return () => {
        return <div id="release-notes">
            <h2>Release Notes</h2>

            <Tabs id="release-notes-tabs"
                activeKey={tab}
                onSelect={setTab}
                animation={false}>
                <Tab eventKey={0} title="Control Center">
                    <ControlCenterChangeLog/>
                </Tab>
                <Tab eventKey={1} title="Media Player">
                    <PlayerChangeLog/>
                </Tab>
                <Tab eventKey={2} title="Channel Listing">
                    <ChannelListingChangeLog/>
                </Tab>
                <Tab eventKey={3} title="Known Issues">
                    <KnownIssues/>
                </Tab>
            </Tabs>
        </div>
    }
}

export default ReleaseNotes;